<template>
    <modal-base :pacifier="false">
        <template #title>Your Appointment is Confirmed</template>

        <template #subtitle>Please contact your Unbundled Lawyer at the scheduled date and time.</template>
    </modal-base>
</template>

<script>
    export default {
        mounted() {
            this.$store.commit('card');

            setTimeout(() => {
                this.$store.commit('started', false);
            }, 5000);
        }
    }
</script>
